if (!customElements.get('length-comparison-modal')) {
  class LengthComparisonModal extends HTMLElement {
    constructor() {
      super()
      this.content = this.querySelector('.length-comparison-modal__content')
    }

    connectedCallback() {
      this.boundClose = this.close.bind(this)
      this.boundStop = function stopPropagation(e) {
        e.stopPropagation()
      }
      this.boundKeydown = this.handleKeydown.bind(this)

      this.addEventListener('click', this.boundClose)
      this.content.addEventListener('click', this.boundStop)
      this.querySelector('.js-close').addEventListener('click', this.boundClose)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClose)
      this.content.removeEventListener('click', this.boundStop)
      this.querySelector('.js-close').removeEventListener('click', this.boundClose)
    }

    // a11y: Escape closes; focus moves in on open and returns to the trigger on close.
    handleKeydown(e) {
      if (e.key === 'Escape') this.close()
    }

    open() {
      this.opener = document.activeElement
      this.classList.add('is-open')
      this.removeAttribute('inert')
      document.addEventListener('keydown', this.boundKeydown)
      this.querySelector('.js-close')?.focus()
    }

    close() {
      this.classList.remove('is-open')
      this.setAttribute('inert', '')
      document.removeEventListener('keydown', this.boundKeydown)
      if (this.opener && document.contains(this.opener)) this.opener.focus()
      this.opener = null
    }
  }
  customElements.define('length-comparison-modal', LengthComparisonModal)
}

if (!customElements.get('open-length-comparison')) {
  class OpenLengthComparison extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleActivate.bind(this))
      this.addEventListener('keydown', this.handleKeydown.bind(this))
    }

    handleActivate() {
      // The trigger's data-comparison-type ('length' by default, 'hem', or
      // 'regular-tall') selects the matching modal instance.
      const comparisonType = this.dataset.comparisonType || 'length'
      const modal = document.querySelector(
        `length-comparison-modal[data-comparison-type='${comparisonType}']`,
      )
      if (modal) modal.open()
    }

    // role="button" elements don't get synthesized clicks for Enter/Space.
    handleKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return
      e.preventDefault()
      this.handleActivate()
    }
  }
  customElements.define('open-length-comparison', OpenLengthComparison)
}
